import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class PlaceAdService {
	private readonly _togglePlaceAdMobile$ = new BehaviorSubject<boolean>(false);
	private readonly _enablePlaceAdMobile$ = new BehaviorSubject<boolean>(false);

	/**
	 * Toggle/display the place ad button fixed bottom
	 */
	get togglePlaceAdMobile$(): Observable<boolean> {
		return this._togglePlaceAdMobile$.asObservable();
	}

	/**
	 * Enable the place ad mobile to display/toggle.
	 * Enable only on home and ads page the place ad button fixed bottom
	 */
	get enablePlaceAdMobile$(): Observable<boolean> {
		return this._enablePlaceAdMobile$.asObservable();
	}

	setTogglePlaceAdMobile(togglePlaceAdMobile: boolean): void {
		this._togglePlaceAdMobile$.next(togglePlaceAdMobile);
	}

	setEnablePlaceAdMobile(enablePlaceAdMobile: boolean): void {
		this._enablePlaceAdMobile$.next(enablePlaceAdMobile);
	}
}
